<template>
  <el-container class="app-layout-404">
    <el-header style="padding:0;">
      <transition name="el-fade-in-linear">
        <app-header></app-header>
      </transition>
    </el-header>
    <el-container>
      <transition name="el-fade-in-linear">
        <router-view></router-view>
      </transition>
    </el-container>
</el-container>
</template>

<script>
import AppHeader from './header'
export default {
  name: 'Layout',
  components: {
    AppHeader,
  }
}
</script>

<style>
  .app-layout-404 {
      width: 100%;
      height: 100%;
  }
</style>
